import apiClient from '../apiClient';

// ============================================================
// Session Management
// ============================================================

export const createSession = (options = {}) => {
  return apiClient.post('/provisioning/sessions', options);
};

export const getSession = (sessionId) => {
  return apiClient.get(`/provisioning/sessions/${sessionId}`);
};

export const updateSession = (sessionId, data) => {
  return apiClient.put(`/provisioning/sessions/${sessionId}`, data);
};

// ============================================================
// Environment
// ============================================================

export const getEnvironment = () => {
  return apiClient.get('/provisioning/environment');
};

// ============================================================
// Wizard Step Actions
// ============================================================

export const createCustomer = (sessionId, customerData) => {
  return apiClient.post(`/provisioning/sessions/${sessionId}/customer`, customerData);
};

export const copyRulesets = (sessionId, data) => {
  return apiClient.post(`/provisioning/sessions/${sessionId}/rulesets`, data);
};

export const createMetadataFields = (sessionId) => {
  return apiClient.post(`/provisioning/sessions/${sessionId}/metadata`);
};

export const createDeliveryConfig = (sessionId, configData) => {
  return apiClient.post(`/provisioning/sessions/${sessionId}/delivery`, configData);
};

export const searchBfeJobs = (sessionId, searchTerm) => {
  return apiClient.get(`/provisioning/sessions/${sessionId}/bfe-search`, {
    params: { searchTerm }
  });
};

export const parseXmlSchema = (sessionId, schemaData) => {
  return apiClient.post(`/provisioning/sessions/${sessionId}/xml-schema`, schemaData);
};

export const getFieldKeys = (sessionId, rulesetId) => {
  const params = rulesetId ? { rulesetId } : {};
  return apiClient.get(`/provisioning/sessions/${sessionId}/field-keys`, { params });
};

export const createJobs = (sessionId, jobData) => {
  return apiClient.post(`/provisioning/sessions/${sessionId}/jobs`, jobData);
};

export const validateProvisioning = (sessionId) => {
  return apiClient.post(`/provisioning/sessions/${sessionId}/validate`);
};

export const enableCustomer = (sessionId) => {
  return apiClient.post(`/provisioning/sessions/${sessionId}/enable`);
};

export const checkReferenceCustomer = (sessionId, referenceCustomerId) => {
  return apiClient.get(`/provisioning/sessions/${sessionId}/reference-customer-check`, {
    params: { referenceCustomerId }
  });
};

// ============================================================
// Customer Toggle
// ============================================================

export const getToggleStatus = (customerId) => {
  return apiClient.get(`/customers/${customerId}/toggle`);
};

export const setToggleState = (customerId, enabled) => {
  return apiClient.post(`/customers/${customerId}/toggle`, { enabled });
};

export const autoDetectMapping = (customerId) => {
  return apiClient.post(`/customers/${customerId}/toggle/auto-detect`);
};

// ============================================================
// Delivery Defaults
// ============================================================

export const getDeliveryDefaults = () => {
  return apiClient.get('/provisioning/delivery-defaults');
};

// ============================================================
// Ipsnet Search
// ============================================================

export const searchIpsnetJobs = (sessionId, searchTerm) => {
  return apiClient.get(`/provisioning/sessions/${sessionId}/ipsnet-search`, {
    params: { searchTerm }
  });
};


export const getSkippedSteps = (sessionId) => {
  return apiClient.get(`/provisioning/sessions/${sessionId}/skipped-steps`);
};

export const listSessions = (status) => {
  const params = status ? `?status=${status}` : '';
  return apiClient.get(`/provisioning/sessions${params}`);
};
